<template>
	<li class="mb-4 md:mb-8 w-full md:w-1/2 md:px-4">
		<button
			v-bind:class="[
				'border p-3 text-left w-full rounded block group md:p-8 md:text-center md:h-full focus:outline-none',
				selected.includes(index) ? 'border-secondary shadow-outline' : '',
			]"
			@click="$emit('select', index)"
		>
			<ul>
				<li
					class="type-500 md:type-600 text-primary-300 font-60 md:font-70 group-focus:opacity-50"
				>
					{{ answer }}
				</li>
				<li
					v-if="description"
					class="type-300 mt-2 text-mono-500 group-focus:opacity-75"
				>
					{{ description }}
				</li>
			</ul>
		</button>
	</li>
</template>

<script>
export default {
	props: {
		answer: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			default: '',
		},
		index: {
			type: Number,
			required: true,
		},
		id: {
			type: String,
			required: true,
		},
		selected: {
			type: Array,
			required: true,
		},
	},
}
</script>
